import { cn } from "@/lib/utils";

export type CustomIconProps = React.PropsWithoutRef<
  React.SVGProps<SVGSVGElement>
>;

export const Icons = {
  Bars3BottomRight: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M22 5v1.25H2V5zM2 12.25h20V11H2zm10 6h10V17H12z"
      />
    </svg>
  ),
  ArrowRightOnRectangle: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="m21.99 12-7.16 7.16-.88-.88 5.66-5.66H6v-1.25h13.6l-5.65-5.65.88-.88zM3.25 17.43V6.57c0-1.83 1.51-3.32 3.38-3.32H8V2H6.63C4.08 2 2.01 4.05 2.01 6.57v10.86c0 2.52 2.08 4.57 4.62 4.57H8v-1.25H6.63c-1.86 0-3.38-1.49-3.38-3.32"
      />
    </svg>
  ),
  ArrowTopRightOnSquare: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M15.75 14H17v5.41A2.59 2.59 0 0 1 14.41 22H4.59A2.59 2.59 0 0 1 2 19.41V9.6a2.59 2.59 0 0 1 2.59-2.59H10v1.25H4.59c-.74 0-1.34.6-1.34 1.34v9.81c0 .74.6 1.34 1.34 1.34h9.82c.74 0 1.34-.6 1.34-1.34zM12 2v1.25h7.86L8.55 14.56l.88.88L20.74 4.13v7.86h1.25V2h-10Z"
      />
    </svg>
  ),
  HandRaisedFill: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M20 6c0-.55-.45-1-1-1s-1 .45-1 1v7h-1.51V4c0-.55-.45-1-1-1s-1 .45-1 1v9h-1.76V3c0-.55-.45-1-1-1s-1 .45-1 1v10H8.97V4c0-.55-.45-1-1-1s-1 .45-1 1v12h-.61l-1.55-3.5a1.5 1.5 0 0 0-2.01-.68 1.5 1.5 0 0 0-.68 2.01l3.86 8.18h9.99c2.17 0 4-1.71 4-4V6Z"
      />
    </svg>
  ),
  ArrowDown: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M19.16 14.8 12 22.01l-7.16-7.22.89-.88 5.65 5.69V2h1.25v17.6l5.65-5.69.89.88Z"
      />
    </svg>
  ),
  RefundReciept: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M2 2v20l4-2 3 2 3-2 3 2 3-2 4 2V2zm18.75 9.99v7.99l-2.19-1.1-.65-.32-.6.4L15 20.5l-2.31-1.54-.69-.46-.69.46L9 20.5l-2.31-1.54-.6-.4-.65.32-2.19 1.1V3.25h17.5zm-10.06.41L7.14 8.85l3.55-3.55.88.88-2.04 2.04h3.58c2.14 0 3.89 1.74 3.89 3.89S15.26 16 13.11 16H8v-1.25h5.11c1.45 0 2.64-1.18 2.64-2.64s-1.18-2.64-2.64-2.64H9.53l2.04 2.04-.88.88Z"
      />
    </svg>
  ),
  Megaphone: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M22 18 17 2 2 12.72 3.69 18H7v1.99c0 .55.21 1.06.59 1.44.37.37.86.57 1.38.57h4.05c1.09 0 1.97-.9 1.97-2.01V18h7ZM16.32 4.02l3.98 12.73h-2.61l-3.5-11.2zm-3.29 16.73H8.98c-.18 0-.36-.07-.5-.21a.764.764 0 0 1-.23-.55V18h5.49v1.99c0 .42-.32.76-.72.76Zm-8.42-4-1.14-3.54 9.65-6.9 3.26 10.44z"
      />
    </svg>
  ),
  Benchmarks: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M14 2v6H8v6H2v8h20V2zm6.75 7.37v11.38H3.25v-5.5h6v-6h6v-6h5.5z"
      />
    </svg>
  ),
  Cog: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 8.38c-1.29 0-2.49.69-3.14 1.81s-.65 2.51 0 3.62 1.85 1.81 3.14 1.81 2.49-.69 3.14-1.81c.64-1.12.64-2.51 0-3.62A3.636 3.636 0 0 0 12 8.38m2.06 4.81c-.42.73-1.21 1.19-2.06 1.19s-1.63-.46-2.06-1.19c-.42-.73-.42-1.64 0-2.38.42-.73 1.21-1.19 2.06-1.19s1.63.46 2.06 1.19c.42.73.42 1.64 0 2.38m5.54-.38c-.42-.24-.47-.65-.47-.81s.05-.57.47-.81l1.53-.88 1.08-.62-.62-1.08-1.84-3.19-.62-1.08-1.08.62-1.53.88c-.15.09-.31.13-.47.13-.45 0-.94-.36-.94-.94V2.02H8.92v3c0 .58-.49.94-.94.94-.16 0-.32-.04-.47-.13l-1.52-.88-1.08-.62-.62 1.08-1.85 3.2-.62 1.08 1.08.62 1.53.88c.42.24.47.65.47.81s-.05.57-.47.81l-1.53.88-1.08.62.62 1.08 1.84 3.19.62 1.08 1.08-.62 1.53-.88c.15-.09.31-.13.47-.13.45 0 .94.36.94.94v3.01h6.19v-3.03c0-.58.49-.94.94-.94.16 0 .32.04.47.13l1.53.88 1.08.62.62-1.08 1.84-3.18.62-1.08-1.08-.62-1.53-.88Zm-.94 5.15-1.53-.88c-.35-.2-.73-.3-1.09-.3-1.14 0-2.19.91-2.19 2.19v1.78h-3.69v-1.76c0-1.28-1.05-2.19-2.19-2.19-.36 0-.74.09-1.09.3l-1.53.88-1.84-3.19 1.53-.88c1.46-.84 1.46-2.95 0-3.79l-1.53-.88 1.85-3.2 1.52.88c.35.2.73.3 1.09.3 1.14 0 2.19-.91 2.19-2.19V3.28h3.69v1.76c0 1.28 1.05 2.19 2.19 2.19.36 0 .74-.09 1.09-.3l1.53-.88 1.84 3.19-1.53.88c-1.46.84-1.46 2.95 0 3.79l1.53.88-1.84 3.18Z"
      />
    </svg>
  ),
  ExclimationTriangle: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M21.65 17.21 14.97 3.83C14.41 2.7 13.27 2 12 2s-2.4.7-2.97 1.83L2.35 17.21c-.52 1.04-.46 2.24.15 3.23a3.3 3.3 0 0 0 2.82 1.57h13.36c1.16 0 2.21-.58 2.82-1.57.61-.98.66-2.19.15-3.23m-1.21 2.57c-.38.61-1.04.98-1.76.98H5.32a2.068 2.068 0 0 1-1.85-2.99l6.68-13.38c.36-.72 1.05-1.14 1.85-1.14s1.49.43 1.85 1.14l6.68 13.38c.32.64.29 1.4-.09 2.01m-7.82-5.77h-1.25v-7h1.25zm.38 3c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1"
      />
    </svg>
  ),
  ChevronUpMini: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="m17.6 14.14-.88.88L12 10.3l-4.71 4.71-.88-.88L12 8.54z"
      />
    </svg>
  ),
  XCircle: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M19.07 4.93C17.12 2.98 14.56 2 12 2s-5.12.98-7.07 2.93c-3.91 3.91-3.91 10.24 0 14.14C6.88 21.02 9.44 22 12 22s5.12-.98 7.07-2.93c3.91-3.91 3.91-10.24 0-14.14m-.88 13.26c-1.65 1.65-3.85 2.56-6.19 2.56s-4.53-.91-6.19-2.56c-3.41-3.41-3.41-8.96 0-12.37C7.46 4.17 9.66 3.26 12 3.26s4.53.91 6.19 2.56c3.41 3.41 3.41 8.96 0 12.37M16.94 7.94 12.88 12l4.06 4.06-.88.88L12 12.88l-4.06 4.06-.88-.88L11.12 12 7.06 7.94l.88-.88L12 11.12l4.06-4.06z"
      />
    </svg>
  ),
  BankNotes: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 6.25h6.26L12.99 22h1.32l3.26-9.74h2.71L17.03 22h1.32l3.67-10.99h-4.03L20 5h-7.99V2H2v20h10V12zm-1.25 14.5h-7.5v-6.78C4.17 14.6 5.5 15 7 15s2.83-.41 3.75-1.03zm0-8.75c0 .71-1.46 1.75-3.75 1.75S3.25 12.71 3.25 12 4.71 10.25 7 10.25s3.75 1.04 3.75 1.75m0-1.97C9.83 9.4 8.5 9 7 9s-2.83.41-3.75 1.03V3.25h7.5z"
      />
    </svg>
  ),
  Home: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 2 2 11v11h20V11zm8.75 18.75H3.25v-9.19L12 3.68l8.75 7.87v9.19Z"
      />
    </svg>
  ),
  Wholesale: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M17 11V2H7v9H2v11h20V11zM8.25 3.25h7.5V11h-7.5zm3.13 17.5H3.25v-8.5h8.13zm9.37 0h-8.12v-8.5h8.12z"
      />
    </svg>
  ),
  Briefcase: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M19 5h-3V2H8v3H5C3.34 5 2 6.34 2 8v14h20V8c0-1.66-1.34-3-3-3M9.25 3.25h5.5V5h-5.5zm11.5 17.5H3.25v-7.5h8.12V16h1.25v-2.75h8.12v7.5Zm0-8.75H3.25V8c0-.96.79-1.75 1.75-1.75h14c.96 0 1.75.79 1.75 1.75z"
      />
    </svg>
  ),
  EllipsisVertical: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M10.5 5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5M12 17.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5m0-7c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5"
      />
    </svg>
  ),
  Map: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="m22 2-6.63 2-6.74-2L2 4v18l6.63-2 6.74 2L22 20zM8 18.88l-4.75 1.43V4.93L8 3.5v15.39Zm6.75 1.63-5.49-1.63V3.49l5.49 1.63zm1.25 0V5.12l4.75-1.43v15.39z"
      />
    </svg>
  ),
  Inbox: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M2 2v20h20V2zm18.75 18.75H3.25v-7.5h4.23c.31 2.22 2.22 3.94 4.52 3.94s4.22-1.72 4.52-3.94h4.23zm0-8.75h-5.43v.62c0 1.83-1.49 3.32-3.32 3.32s-3.32-1.49-3.32-3.32V12H3.25V3.25h17.5z"
      />
    </svg>
  ),
  SpeakToAnExpert: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M22 5.24c0-1.79-1.46-3.26-3.25-3.26s-3.26 1.46-3.26 3.26h1.25a2.01 2.01 0 0 1 4.02 0v9.79a4.11 4.11 0 0 0-2.93-1.14c-1.08.03-2.09.49-2.83 1.28-.22.23-.39.49-.55.75a3.123 3.123 0 0 0-2.35-1.18c-.84-.02-1.64.28-2.25.85-.11.1-.2.22-.29.33-.15-.27-.33-.52-.55-.75a4.06 4.06 0 0 0-2.83-1.28c-1.14-.04-2.17.4-2.93 1.13V5.25c0-1.11.9-2.01 2-2.01s2.01.9 2.01 2.01h1.25c0-1.79-1.46-3.26-3.26-3.26S1.99 3.45 1.99 5.25v12.47h.02s-.01.06-.01.09a4.062 4.062 0 0 0 3.93 4.18h.13c2.18 0 3.98-1.74 4.05-3.93 0-.08-.01-.16-.02-.24h.01c.02-.51.23-.98.6-1.32.37-.35.86-.54 1.36-.51 1.03.03 1.83.86 1.83 1.9h.01c0 .06-.01.12-.01.18A4.061 4.061 0 0 0 17.94 22h.13c2.23-.07 4-1.95 3.93-4.18 0-.04-.01-.07-.01-.11H22zM5.97 20.74a2.812 2.812 0 0 1-2.72-2.89c.05-1.52 1.3-2.72 2.8-2.72h.09c.75.02 1.44.34 1.96.88.51.55.78 1.26.76 2.01a2.799 2.799 0 0 1-2.89 2.72m12.06 0c-1.54.06-2.84-1.17-2.89-2.72-.02-.75.25-1.46.76-2.01.51-.55 1.21-.86 1.96-.88h.09a2.805 2.805 0 0 1 .08 5.61"
      />
    </svg>
  ),
  ChatBubble: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M17 14.25H7V13h10zm0-4.5H7V11h10zM22 22H7.31C4.39 22 2 19.6 2 16.68V7.3C2 4.38 4.39 2 7.31 2h9.38C19.61 2 22 4.38 22 7.3v6.69c0 2.36-1.57 4.34-3.7 5.03zM7.31 20.75h11.15l-.94-.76-1.8-1.45 2.2-.71c1.7-.55 2.84-2.09 2.84-3.84V7.3a4.06 4.06 0 0 0-4.06-4.05H7.31c-2.24 0-4.06 1.81-4.06 4.05v9.38c0 2.25 1.82 4.07 4.06 4.07"
      />
    </svg>
  ),
  HelpCenter: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M18.3 19.02c2.14-.69 3.7-2.68 3.7-5.03V7.3C22 4.38 19.61 2 16.69 2H7.31C4.39 2 2 4.38 2 7.3v9.38C2 19.6 4.39 22 7.31 22H22zM3.25 16.68V7.3a4.06 4.06 0 0 1 4.06-4.05h9.38c2.24 0 4.06 1.81 4.06 4.05v6.69c0 1.75-1.14 3.3-2.84 3.84l-2.2.71 1.8 1.45.94.76H7.31c-2.24 0-4.06-1.83-4.06-4.07M17 10c0 2.76-2.24 5-5 5s-5-2.24-5-5h1.25c0 2.07 1.68 3.75 3.75 3.75s3.75-1.68 3.75-3.75z"
      />
    </svg>
  ),
  ChevronUp: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="m20.37 15.53-.88.88-7.5-7.5-7.48 7.48-.88-.88 8.36-8.36z"
      />
    </svg>
  ),
  TableCells: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M2 3v18h20V3zm9.38 16.75H3.25v-4.13h8.12v4.13Zm0-5.37H3.25V9.63h8.12v4.75Zm0-6H3.25V4.26h8.12v4.12Zm9.37 11.37h-8.12v-4.13h8.12zm0-5.37h-8.12V9.63h8.12zm0-6h-8.12V4.26h8.12z"
      />
    </svg>
  ),
  ArrowPath: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M22 8.84V9h-1.25v-.16c0-3.08-2.5-5.58-5.58-5.58-1.54 0-2.92.55-3.98 1.55l-6.93 6.56h5.22v1.25H2V5.13h1.25v5.47l7.08-6.71a6.9 6.9 0 0 1 4.75-1.9c3.85 0 6.91 3.06 6.91 6.83Zm-7.5 3.78h5.24l-6.93 6.56c-1.06 1-2.44 1.55-3.98 1.55-3.08 0-5.58-2.5-5.58-5.58v-.16H2v.16c0 3.77 3.07 6.83 6.91 6.83 1.78 0 3.47-.67 4.75-1.89l7.08-6.71v5.47h1.25v-7.49h-7.5v1.25Z"
      />
    </svg>
  ),
  HandThumbUp: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M20.31 12.86c.62-.51 1.01-1.28 1.01-2.13 0-1.53-1.24-2.77-2.76-2.77h-4.61c.91-1.99 1.09-3.61.51-4.74-.41-.81-1.19-1.31-2.24-1.45l-.41-.05-.21.35c-2.9 4.84-8.25 8.26-8.31 8.29l-.29.18v7.84c0 1.96 1.69 3.61 3.7 3.61h11.85c1.52 0 2.76-1.24 2.76-2.76 0-.85-.39-1.62-1.01-2.13.62-.51 1.01-1.28 1.01-2.13s-.39-1.62-1.01-2.13Zm-.24 2.13c0 .79-.62 1.45-1.42 1.5v1.25c.8.05 1.42.71 1.42 1.5 0 .84-.68 1.52-1.51 1.52H6.7c-1.33 0-2.45-1.08-2.45-2.37v-7.16c1.17-.78 5.48-3.84 8.18-8.12.43.12.73.36.9.7.45.88.1 2.52-.96 4.5l-.5.92h6.67c.83 0 1.51.68 1.51 1.52 0 .79-.62 1.45-1.42 1.5v1.25c.8.05 1.42.71 1.42 1.5Z"
      />
    </svg>
  ),
  ChartBars: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M19.25 2v20H18V2zM11 22h1.25V8H11zm-7 0h1.25v-9H4z"
      />
    </svg>
  ),
  FounderToolkit: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M17.2 3H6.8l-4.74 9 4.74 9h10.39l4.74-9-4.74-9Zm-.76 16.75H7.56L3.48 12l4.08-7.75h8.88L20.52 12zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m0 6.75c-1.52 0-2.75-1.23-2.75-2.75S10.48 9.25 12 9.25s2.75 1.23 2.75 2.75-1.23 2.75-2.75 2.75"
      />
    </svg>
  ),
  ChevronRight: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="m16.85 11.99-8.38 8.38-.88-.88 7.5-7.5-7.48-7.48.88-.88L16.86 12Z"
      />
    </svg>
  ),
  PressRoom: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M22 18 17 2 2 12.72 3.69 18H7v1.99c0 .55.21 1.06.59 1.44.37.37.86.57 1.38.57h4.05c1.09 0 1.97-.9 1.97-2.01V18h7ZM16.32 4.02l3.98 12.73h-2.61l-3.5-11.2zm-3.29 16.73H8.98c-.18 0-.36-.07-.5-.21a.764.764 0 0 1-.23-.55V18h5.49v1.99c0 .42-.32.76-.72.76Zm-8.42-4-1.14-3.54 9.65-6.9 3.26 10.44z"
      />
    </svg>
  ),
  Bars3BottomLeft: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M22 5v1.25H2V5zM2 12.25h20V11H2zm0 6h10V17H2z"
      />
    </svg>
  ),
  Link: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="outline_positive"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M5.38 18.37a4.173 4.173 0 0 1-1.97-2.58 4.21 4.21 0 0 1 .42-3.22l2.39-4.14a4.247 4.247 0 0 1 5.8-1.55 4.247 4.247 0 0 1 1.55 5.8l1.08.62c1.51-2.62.61-5.99-2.01-7.5-2.62-1.52-5.99-.61-7.5 2.01l-2.39 4.14a5.472 5.472 0 0 0-.54 4.17 5.453 5.453 0 0 0 2.56 3.34c.84.49 1.79.73 2.73.73 1.12 0 2.22-.35 3.16-1l-1.23-.71c-1.26.63-2.79.62-4.04-.09Z"
      />
    </svg>
  ),
  ArrowRight: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="m22 12-7.21 7.16-.88-.89 5.69-5.65H2v-1.25h17.59L13.9 5.72l.88-.89 7.21 7.16Z"
      />
    </svg>
  ),
  Envelope: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M2 2v20h20V2zm17.85 1.25L12 11.12 4.13 3.25h15.71Zm.9 17.5H3.25V4.13L12 12.88l8.75-8.77v16.63Z"
      />
    </svg>
  ),
  PaperClip: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M19.75 2v11c0 4.27-3.48 7.75-7.75 7.75S4.25 17.27 4.25 13V8.5c0-2.89 2.36-5.25 5.25-5.25s5.25 2.36 5.25 5.25V13c0 1.52-1.23 2.75-2.75 2.75S9.25 14.52 9.25 13V8H8v5c0 2.21 1.79 4 4 4s4-1.79 4-4V8.5C16 4.92 13.08 2 9.5 2S3 4.92 3 8.5V13c0 4.96 4.04 9 9 9s9-4.04 9-9V2z"
      />
    </svg>
  ),
  InProgress: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="outline_positive"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M9.72 5.48c3.34 0 6.06 2.72 6.06 6.06h1.25c0-4.03-3.28-7.31-7.31-7.31s-7.31 3.28-7.31 7.31h1.25c0-3.34 2.72-6.06 6.06-6.06"
      />
    </svg>
  ),
  Bars3: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M22 5v1.25H2V5zM2 12.25h20V11H2zm0 6h20V17H2z"
      />
    </svg>
  ),
  BookOpen: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M16.69 3c-2.05 0-3.8.79-4.69 1.99C11.11 3.8 9.37 3 7.31 3 4.33 3 2 4.67 2 6.81V21h1.25c0-1.39 1.86-2.56 4.06-2.56s4.06 1.17 4.06 2.56h1.25c0-1.39 1.86-2.56 4.06-2.56s4.06 1.17 4.06 2.56h1.25V6.81c0-2.13-2.33-3.81-5.31-3.81Zm-5.31 15.53c-.97-.82-2.41-1.34-4.06-1.34s-3.09.51-4.06 1.33V6.81c0-1.39 1.86-2.56 4.06-2.56s4.06 1.17 4.06 2.56zm9.37-.01c-.97-.82-2.42-1.33-4.06-1.33s-3.09.52-4.06 1.34V6.81c0-1.39 1.86-2.56 4.06-2.56s4.06 1.17 4.06 2.56z"
      />
    </svg>
  ),
  ArrowDownTray: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="m12 18-7.16-7.16.88-.88 5.65 5.65V2h1.25v13.61l5.65-5.65.88.88L11.99 18Zm8.75-2v1.37c0 1.86-1.49 3.38-3.32 3.38H6.57c-1.83 0-3.32-1.52-3.32-3.38V16H2v1.37C2 19.92 4.05 22 6.57 22h10.85c2.52 0 4.57-2.08 4.57-4.63V16h-1.25Z"
      />
    </svg>
  ),
  PencilSquare: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="m4.45 11.5 6.57 6.5h6.99v-6.96l-6.5-6.6-1.39-1.39c-1.45-1.45-3.75-1.32-5.37.29l-1.5 1.5c-1.58 1.58-1.66 3.8-.19 5.27zm12.3.05v5.2h-5.22l-5.4-5.35 2.2-2.2 5.24 5.25.88-.88-5.24-5.25 2.2-2.2 5.35 5.43ZM4.13 5.72l1.5-1.5c1.11-1.11 2.66-1.23 3.6-.29l1.29 1.29-5.29 5.29-1.29-1.29c-.97-.97-.9-2.41.19-3.5M22 2v20H2v-7h1.25v5.75h17.5V3.25H15V2z"
      />
    </svg>
  ),
  CloudArrowUp: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M21.98 12c0 1.75-.46 3.48-1.33 4.99l-1.08-.63A8.763 8.763 0 0 0 20.74 12c0-4.81-3.92-8.73-8.73-8.73S3.27 7.19 3.27 12c0 1.5.39 2.98 1.12 4.27l-1.09.61c-.83-1.48-1.28-3.17-1.28-4.89C2.02 6.5 6.5 2.02 12 2.02S21.98 6.5 21.98 12m-15.46.48.88.88 3.97-3.97V22h1.25V9.39l3.97 3.97.88-.88L11.99 7l-5.48 5.48Z"
      />
    </svg>
  ),
  ExclimationCircle: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18.75c-4.82 0-8.75-3.93-8.75-8.75S7.18 3.25 12 3.25s8.75 3.93 8.75 8.75-3.93 8.75-8.75 8.75m.62-7.75h-1.25V6h1.25zm.38 3c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1"
      />
    </svg>
  ),
  SortBoth: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="m16.33 13.93.88.88L12 20.02l-5.21-5.21.88-.88 3.7 3.7V6.36l-3.7 3.7-.88-.88L12 3.97l5.21 5.21-.88.88-3.7-3.7v11.27z"
      />
    </svg>
  ),
  Bell: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M22 18s-3-4-3-9c0-3.84-3.14-6.99-6.99-7-3.85 0-6.99 3.16-6.99 7 0 5.2-3 9-3 9H9.2c-.11.31-.18.65-.18 1 0 1.66 1.35 3 3 3s3-1.35 3-3c0-.35-.07-.69-.18-1h7.18Zm-10 2.75c-.97 0-1.75-.79-1.75-1.75 0-.37.12-.71.32-1h2.87c.2.28.32.63.32 1 0 .97-.79 1.75-1.75 1.75Zm-.01-4H4.25c.92-1.74 2-4.48 2-7.75s2.55-5.72 5.69-5.75.05 0 .05 0c3.17 0 5.74 2.59 5.74 5.75s1.11 5.98 2.03 7.75h-7.79Z"
      />
    </svg>
  ),
  Partnerships: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M16.68 7.32A7.503 7.503 0 0 0 2 9.5c0 3.38 2.24 6.24 5.32 7.18A7.503 7.503 0 0 0 22 14.5c0-3.38-2.24-6.24-5.32-7.18m-9.65 7.92A6.26 6.26 0 0 1 3.25 9.5c0-3.45 2.8-6.25 6.25-6.25a6.26 6.26 0 0 1 5.74 3.78c-.25-.02-.49-.04-.75-.04-4.14 0-7.5 3.36-7.5 7.5 0 .25.01.5.04.75m1.22-.74c0-3.45 2.8-6.25 6.25-6.25.39 0 .77.04 1.14.11.07.37.11.75.11 1.14 0 3.45-2.8 6.25-6.25 6.25-.39 0-.77-.04-1.14-.11a6.12 6.12 0 0 1-.11-1.14m6.25 6.25a6.26 6.26 0 0 1-5.74-3.78c.25.02.49.04.75.04 4.14 0 7.5-3.36 7.5-7.5 0-.25-.01-.5-.04-.75a6.26 6.26 0 0 1 3.78 5.74c0 3.45-2.8 6.25-6.25 6.25"
      />
    </svg>
  ),
  Flag: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M22 3H9L1.99 21h1.34l2.72-7h15.94L16 8.5 21.99 3Zm-3.21 9.75H6.55l2.41-6.2.89-2.3h8.94l-3.62 3.33-1 .92 1 .92z"
      />
    </svg>
  ),
  Cube: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 1.95 3 6.97v10.07l9 5.02 9-5.02V6.97zm-.62 18.32L4.25 16.3V8.4l7.13 3.97zM4.91 7.33 12 3.38l7.09 3.95L12 11.28zm14.84 8.97-7.13 3.97v-7.9l7.13-3.97z"
      />
    </svg>
  ),
  Document: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M14.24 2H3v20h18V8.77C21 5.03 17.97 2 14.24 2m.01 1.25c1.47 0 2.85.58 3.88 1.61a5.46 5.46 0 0 1 1.61 3.89h-5.5v-5.5Zm5.5 17.5H4.25V3.25H13V10h6.75z"
      />
    </svg>
  ),
  Check: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M22 5.02 9.01 18.01l-5.57-5.57.88-.88L9 16.24 21.11 4.13l.88.88Z"
      />
    </svg>
  ),
  ToDo: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M8.52 20.03c.78.34 1.62.56 2.48.66v1.26a9.99 9.99 0 0 1-3.1-.84zM3.32 13H2.05c.11 1.06.39 2.11.84 3.1l1.09-.63c-.34-.8-.56-1.63-.66-2.48ZM13 3.31c.86.1 1.7.32 2.48.66l.62-1.08a9.99 9.99 0 0 0-3.1-.84zm0 17.38v1.26a9.99 9.99 0 0 0 3.1-.84l-.62-1.08c-.78.34-1.62.56-2.48.66M8.52 3.97c.78-.34 1.62-.56 2.48-.66V2.05a9.99 9.99 0 0 0-3.1.84zM3.98 8.52l-1.09-.63a9.99 9.99 0 0 0-.84 3.1h1.27c.1-.85.32-1.68.66-2.48Zm1 8.69-1.09.63c.31.43.65.85 1.04 1.24s.8.73 1.24 1.04l.63-1.09c-.34-.25-.67-.53-.98-.83s-.58-.64-.83-.98Zm15.04-1.73 1.09.63c.45-.99.73-2.04.84-3.1h-1.27c-.1.85-.32 1.68-.66 2.48Zm-1.83 2.71c-.31.31-.64.58-.98.83l.63 1.09c.43-.31.85-.65 1.24-1.04s.73-.8 1.04-1.24l-1.09-.63c-.25.34-.52.67-.83.98ZM4.93 4.93c-.39.39-.73.8-1.04 1.24l1.09.63c.25-.34.52-.67.83-.98s.64-.58.98-.83L6.16 3.9c-.43.31-.85.65-1.24 1.04ZM20.68 11h1.27a9.99 9.99 0 0 0-.84-3.1l-1.09.63c.34.8.56 1.63.66 2.48Zm-1.66-4.21 1.09-.63c-.31-.43-.65-.85-1.04-1.24s-.8-.73-1.24-1.04l-.63 1.09c.34.25.67.53.98.83s.58.64.83.98Z"
      />
    </svg>
  ),
  Funder: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="m14.56 2.02-1 .75 6.43 8.61h-6.01c-.09-2.35-.66-4.66-1.74-6.45C11.07 2.98 9.53 2 8 2s-3.07.98-4.24 2.93c-2.34 3.91-2.34 10.24 0 14.14C4.93 21.02 6.47 22 8 22s3.07-.98 4.24-2.93c1.08-1.79 1.65-4.1 1.74-6.45h5.99l-6.42 8.61 1 .75 7.45-10zm-3.39 16.41c-.9 1.5-2.02 2.32-3.17 2.32s-2.27-.82-3.17-2.32c-.95-1.59-1.45-3.68-1.53-5.81h9.41c-.09 2.13-.58 4.22-1.53 5.81ZM3.3 11.37c.09-2.13.58-4.21 1.53-5.8.9-1.5 2.02-2.32 3.17-2.32s2.27.82 3.17 2.32c.95 1.59 1.45 3.67 1.53 5.8z"
      />
    </svg>
  ),
  UserPlus: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M9.99 2c-2.49 0-4.5 2.01-4.5 4.5 0 1.53.76 2.87 1.93 3.68C4.27 11.25 2 14.23 2 17.74c0 1.57.46 3.02 1.24 4.26h1.53a6.693 6.693 0 0 1-1.52-4.26c0-3.72 3.02-6.74 6.74-6.74 2.49 0 4.5-2.01 4.5-4.5S12.48 2 9.99 2m0 7.75c-1.79 0-3.25-1.46-3.25-3.25S8.2 3.25 9.99 3.25s3.25 1.46 3.25 3.25-1.46 3.25-3.25 3.25m7.99 7.99c0 1.57-.46 3.02-1.24 4.26h-1.53a6.693 6.693 0 0 0 1.52-4.26c0-2.26-1.12-4.35-3-5.61l.69-1.04a7.977 7.977 0 0 1 3.56 6.65m4.01-9.36v1.25h-2.38v2.38h-1.25V9.63h-2.38V8.38h2.38V6h1.25v2.38z"
      />
    </svg>
  ),
  CheckCircle: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18.75c-4.82 0-8.75-3.93-8.75-8.75S7.18 3.25 12 3.25s8.75 3.93 8.75 8.75-3.93 8.75-8.75 8.75m7.03-11.89-7.6 7.6L6.97 12l.88-.88 3.58 3.58 6.71-6.71.88.88Z"
      />
    </svg>
  ),
  LockClosedFill: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M18.1 10V7.92C18.1 4.65 15.36 2 12 2S5.9 4.66 5.9 7.92V10H2v12h20V10zm-5.48 7.01h-1.25V13h1.25zM16.85 10h-9.7V7.92c0-2.58 2.18-4.67 4.85-4.67s4.85 2.1 4.85 4.67z"
      />
    </svg>
  ),
  Funder2: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M22 4.99 2 2v11l17.1 2.56-15.85 4.76V15H2v7l20-6.01zM3.25 11.92V3.45l8.59 1.28c-1.59.12-2.86 1.96-2.86 4.24 0 2.05 1.02 3.75 2.39 4.16l-8.11-1.21Zm6.98-2.95c0-1.77.93-3.01 1.77-3.01s1.77 1.24 1.77 3.01-.93 3.01-1.77 3.01-1.77-1.24-1.77-3.01m10.52 5.57-8.74-1.31c1.66 0 3.01-1.91 3.01-4.26 0-1.97-.95-3.6-2.23-4.1l7.96 1.19v8.47Z"
      />
    </svg>
  ),
  EyeSlash: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="m21.99 12-3.88 4.14-.14.14-.91-.85 2.91-3.1.31-.33-2.58-2.77.91-.86zm-6.59 4.85c-.78.47-1.65.76-2.58.87l-.62.08.15 1.24.62-.08c1.1-.13 2.13-.48 3.07-1.04l.54-.32-.64-1.07zm-5.29.65.6.18-.35 1.2-.6-.17c-.86-.25-1.67-.66-2.39-1.19l-3.92 3.92-.88-.88 3.86-3.86s-.08-.07-.12-.11l-4.29-4.58 4.29-4.59c1.43-1.55 3.51-2.44 5.7-2.44 1.69 0 3.31.53 4.64 1.5l3.92-3.92.88.88L8.27 16.62c.56.38 1.19.68 1.85.88Zm3.34-7.84c-.43-.27-.93-.42-1.45-.42-1.52 0-2.76 1.24-2.76 2.76 0 .52.15 1.02.42 1.45l3.78-3.78Zm-4.68 4.69C8.28 13.67 8 12.85 8 12c0-2.21 1.8-4.01 4.01-4.01.86 0 1.67.28 2.35.77l1.37-1.37A6.588 6.588 0 0 0 12 6.23c-1.84 0-3.58.74-4.78 2.04L3.72 12l3.49 3.73s.06.05.09.08l1.46-1.46Z"
      />
    </svg>
  ),
  PresentaionChartLine: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M20.74 14V8.18l-7.4 7.49-3.62-3.62-6.48 6.48v2.23h17.5v-3.75h1.25v5H2V2h20v1.25H3.25v13.5l6.48-6.47 3.62 3.62 6.57-6.64h-5.91V6.01h8v8h-1.26Z"
      />
    </svg>
  ),
  Amazon: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M2 2v20h20V2zm18.75 18.75H3.25V3.25h17.5zM5 13h1.25c0 2.72 1.89 4.77 4.39 4.77 2.68 0 5.3-3.11 6.35-4.52H13V12h6v6h-1.25v-3.68c-1.3 1.68-4.06 4.7-7.11 4.7C7.42 19.02 5 16.43 5 13"
      />
    </svg>
  ),
  HandThumbDown: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M17.3 2H5.45C3.93 2 2.69 3.24 2.69 4.76c0 .85.39 1.62 1.01 2.13-.62.51-1.01 1.28-1.01 2.13s.39 1.62 1.01 2.13c-.62.51-1.01 1.28-1.01 2.13 0 1.53 1.24 2.77 2.76 2.77h4.61c-.91 1.99-1.09 3.61-.51 4.74.41.81 1.19 1.31 2.24 1.45l.41.05.21-.35c2.89-4.83 8.25-8.24 8.3-8.28l.29-.18V5.64c0-1.96-1.69-3.61-3.7-3.61Zm2.45 10.77c-1.17.78-5.48 3.84-8.18 8.12-.43-.12-.73-.36-.9-.7-.45-.88-.1-2.52.96-4.5l.5-.92H5.46c-.83 0-1.51-.68-1.51-1.52 0-.79.62-1.45 1.42-1.5V10.5c-.8-.05-1.42-.71-1.42-1.5s.62-1.45 1.42-1.5V6.25a1.51 1.51 0 0 1-1.42-1.5c0-.84.68-1.52 1.51-1.52h11.85c1.33 0 2.45 1.08 2.45 2.37v7.16Z"
      />
    </svg>
  ),
  Trash: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M5 22h14l1.99-15H3zm12.9-1.25H6.09L4.42 8.25h15.13l-1.66 12.5Zm4.1-16V6H2V4.75h9.38V2h1.25v2.75h9.38ZM12.62 19h-1.25v-9h1.25zm3.51 0h-1.25v-9h1.25zm-7.01 0H7.87v-9h1.25z"
      />
    </svg>
  ),
  ExclimationTriangleFill: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M21.65 17.2 14.97 3.82c-.57-1.13-1.7-1.83-2.97-1.83s-2.4.7-2.97 1.83L2.35 17.2c-.52 1.04-.46 2.24.15 3.23A3.3 3.3 0 0 0 5.32 22h13.36a3.3 3.3 0 0 0 2.82-1.57c.61-.98.66-2.19.15-3.23M11.38 7h1.25v7h-1.25zM12 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1"
      />
    </svg>
  ),
  Careers: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M19 5h-3V2H8v3H5C3.34 5 2 6.34 2 8v14h20V8c0-1.66-1.34-3-3-3M9.25 3.25h5.5V5h-5.5zm11.5 17.5H3.25v-7.5h8.12V16h1.25v-2.75h8.12v7.5Zm0-8.75H3.25V8c0-.96.79-1.75 1.75-1.75h14c.96 0 1.75.79 1.75 1.75z"
      />
    </svg>
  ),
  Wrench: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="m20.99 5.9-.39-.76-3.57 3.56c-.54.54-1.41.54-1.94 0-.54-.54-.54-1.41 0-1.94l3.57-3.57-.77-.39a7.095 7.095 0 0 0-8.28 1.31 7.118 7.118 0 0 0-1.5 7.87L1.99 18.3l3.71 3.71 6.13-6.32c2.67 1.15 5.78.58 7.86-1.5A7.11 7.11 0 0 0 21 5.91Zm-2.19 7.39a5.864 5.864 0 0 1-6.83 1.08l-.41-.21-5.88 6.06-1.94-1.95 5.88-6.06-.2-.4a5.862 5.862 0 0 1 1.07-6.83c1.6-1.6 3.93-2.12 6.02-1.42l-2.3 2.3a2.632 2.632 0 0 0 0 3.71 2.632 2.632 0 0 0 3.71 0l2.3-2.3c.7 2.09.18 4.42-1.42 6.01Z"
      />
    </svg>
  ),
  ReceiptRefund: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M2 2v20l4-2 3 2 3-2 3 2 3-2 4 2V2zm11.11 14H8v-1.25h5.11c1.45 0 2.64-1.18 2.64-2.64s-1.18-2.64-2.64-2.64H9.53l2.04 2.04-.88.88-3.55-3.55 3.55-3.55.88.88-2.04 2.04h3.58c2.14 0 3.89 1.74 3.89 3.89s-1.74 3.89-3.89 3.89Z"
      />
    </svg>
  ),
  BuildingOffice: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="outline_positive"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M2 2v20h20V2zm18.75 18.75h-8.12V17h-1.25v3.75H3.25V3.25h17.5z"
      />
    </svg>
  ),
  AboutUs: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M19.07 4.93C17.12 2.98 14.56 2 12 2s-5.12.98-7.07 2.93c-3.91 3.91-3.91 10.24 0 14.14C6.88 21.02 9.44 22 12 22s5.12-.98 7.07-2.93c3.91-3.91 3.91-10.24 0-14.14m-.88 13.26c-1.65 1.65-3.85 2.56-6.19 2.56s-4.53-.91-6.19-2.56c-3.41-3.41-3.41-8.96 0-12.37C7.46 4.17 9.66 3.26 12 3.26s4.53.91 6.19 2.56c3.41 3.41 3.41 8.96 0 12.37M8 6h8v1.25h-3.37v9.5H16V18H8v-1.25h3.37v-9.5H8z"
      />
    </svg>
  ),
  PlusCircle: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18.75c-4.82 0-8.75-3.93-8.75-8.75S7.18 3.25 12 3.25s8.75 3.93 8.75 8.75-3.93 8.75-8.75 8.75m.62-9.37H18v1.25h-5.38v5.38h-1.25v-5.38H5.99v-1.25h5.38V6h1.25z"
      />
    </svg>
  ),
  ArrowTrendingUp: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M20.75 14V7.15l-8.19 8.14-3.54-3.54-5.77 5.83v3.18H22v1.25H2V2h1.25v13.8l5.76-5.82 3.55 3.55 7.32-7.27H13V5.01h9v9h-1.25Z"
      />
    </svg>
  ),
  InformationCircle: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="outline_positive"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M8 7.25h3.38v9.5H8V18h8v-1.25h-3.38v-9.5H16V6H8z"
      />
    </svg>
  ),
  Pencil: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="m11.51 4.44-1.39-1.39c-1.45-1.45-3.75-1.32-5.37.29l-1.5 1.5c-1.58 1.58-1.66 3.8-.19 5.27l1.39 1.39L15.02 22h6.99v-6.96zM3.94 9.22c-.97-.97-.9-2.41.19-3.5l1.5-1.5c1.11-1.11 2.66-1.23 3.6-.29l1.29 1.29-5.29 5.29zm16.81 11.53h-5.22L6.12 11.4l2.2-2.2 9 9 .88-.88-9-9 2.2-2.2 9.34 9.44v5.2Z"
      />
    </svg>
  ),
  UserGroup: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M21.99 17.6c0 1.63-.5 3.15-1.35 4.4h-1.59a6.573 6.573 0 0 0-1.24-9.89l.69-1.04c2.19 1.46 3.5 3.9 3.5 6.53ZM9 11.06V9.55c-1.38-.37-2.41-1.63-2.41-3.13S7.62 3.67 9 3.29V2c-2.08.4-3.66 2.22-3.66 4.42 0 1.56.79 2.93 2 3.74-3.1 1.05-5.35 3.98-5.35 7.43 0 1.63.5 3.15 1.35 4.4h1.59a6.573 6.573 0 0 1-1.7-4.4c0-3.35 2.51-6.12 5.75-6.54Zm9.64-4.56c0 2.49-2.01 4.5-4.5 4.5-3.64 0-6.6 2.96-6.6 6.6 0 1.69.65 3.23 1.7 4.4H7.67a7.775 7.775 0 0 1-1.37-4.4c0-3.43 2.21-6.34 5.28-7.41A4.474 4.474 0 0 1 9.65 6.5c0-2.49 2.01-4.5 4.5-4.5s4.5 2.01 4.5 4.5Zm-1.25 0c0-1.79-1.46-3.25-3.25-3.25s-3.25 1.46-3.25 3.25 1.46 3.25 3.25 3.25 3.25-1.46 3.25-3.25"
      />
    </svg>
  ),
  DocumentDuplicate: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M15.24 2H5v20h17V8.77C22 5.03 18.97 2 15.24 2m.01 1.25c1.47 0 2.85.58 3.88 1.61a5.46 5.46 0 0 1 1.61 3.89h-5.5v-5.5Zm5.5 17.5H6.25V3.25H14V10h6.75zM2 20h1.25v2H2zm0-5h1.25v4H2zM2 5h1.25v4H2zm0 5h1.25v4H2zm0-8h1.25v2H2z"
      />
    </svg>
  ),
  BuildingStorefront: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M19 2H5L2 6.99V22h20V6.99zM5.71 3.25H18.3l1.88 3.12H3.83zm15.04 17.5h-8.12V16h-1.25v4.75H3.25v-8.98c.67.6 1.54.98 2.5.98 1.3 0 2.45-.67 3.12-1.68.67 1.01 1.82 1.68 3.12 1.68s2.45-.67 3.12-1.68a3.745 3.745 0 0 0 3.12 1.68c.96 0 1.84-.38 2.5-.98v8.98Zm0-11.75a2.5 2.5 0 0 1-5 0H14.5a2.5 2.5 0 0 1-5 0H8.25a2.5 2.5 0 0 1-2.5 2.5c-.67 0-1.3-.26-1.77-.73S3.25 9.67 3.25 9V7.62h17.5z"
      />
    </svg>
  ),
  Clock: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M12.62 11.38H16v1.25h-4.62V5.01h1.25v6.38ZM22 12c0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2s10 4.48 10 10m-1.25 0c0-4.82-3.93-8.75-8.75-8.75S3.25 7.18 3.25 12s3.93 8.75 8.75 8.75 8.75-3.93 8.75-8.75"
      />
    </svg>
  ),
  Eye: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m0 6.75c-1.52 0-2.75-1.23-2.75-2.75S10.48 9.25 12 9.25s2.75 1.23 2.75 2.75-1.23 2.75-2.75 2.75m5.74-7.3C16.35 5.95 14.3 5 12 5s-4.35.95-5.73 2.45L2.01 12l4.26 4.55C7.66 18.05 9.71 19 12 19s4.35-.95 5.74-2.45L22 12zm-.92 8.25c-1.21 1.3-2.96 2.05-4.82 2.05S8.39 17 7.18 15.7L3.72 12l3.47-3.7c1.2-1.3 2.96-2.05 4.82-2.05s3.62.75 4.83 2.06L20.3 12l-3.47 3.7Z"
      />
    </svg>
  ),
  ChevronDoubleRight: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="m20.33 11.99-8.38 8.38-.88-.88 7.5-7.5-7.48-7.48.88-.88L20.34 12ZM5.02 3.63l-.88.88 7.48 7.48-7.5 7.5.88.88 8.38-8.38z"
      />
    </svg>
  ),
  Bars3BottomCenter: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M22 5v1.25H2V5zM2 12.25h20V11H2zm5 6h10V17H7z"
      />
    </svg>
  ),
  Gift: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="m12.87 8 4.58-4.71-.9-.87-3.93 4.04V2h-1.25v4.46L7.44 2.42l-.9.87L11.12 8H2v14h20V8zm-1.49 12.75H3.25V9.25h8.13zm9.37 0h-8.12V9.25h8.12z"
      />
    </svg>
  ),
  QuestionMarkCircle: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18.75c-4.82 0-8.75-3.93-8.75-8.75S7.18 3.25 12 3.25s8.75 3.93 8.75 8.75-3.93 8.75-8.75 8.75m3.89-11.72c0 1.69-1.24 2.97-2.89 2.97h-.38v2h-1.25v-3.25h1.62c.95 0 1.64-.72 1.64-1.72s-.79-1.77-1.76-1.77h-1.76c-.97 0-1.76.78-1.76 1.74H8.1c0-1.65 1.35-2.99 3.01-2.99h1.76c1.66 0 3.01 1.35 3.01 3.02ZM13 17c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1"
      />
    </svg>
  ),
  BuildingLibrary: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 2 2 8.98V22h20V8.98zm0 1.52L19.85 9H4.15zM7.75 20.75h-4.5v-10.5h1.87c1.45 0 2.63 1.17 2.63 2.61zM15 12.86v7.89h-2.38V17h-1.25v3.75H8.99v-7.89c0-1.01-.4-1.92-1.04-2.61h8.08c-.64.69-1.04 1.6-1.04 2.61Zm5.75 7.89h-4.5v-7.89c0-1.44 1.18-2.61 2.63-2.61h1.86v10.5Z"
      />
    </svg>
  ),
  Share: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M17.5 8.36c-1.12 0-2.11.52-2.78 1.31L9.93 6.91c.14-.39.23-.81.23-1.25 0-2.02-1.64-3.65-3.65-3.65S2.86 3.65 2.86 5.66 4.5 9.31 6.51 9.31c1.13 0 2.12-.52 2.79-1.32l4.78 2.76c-.15.39-.24.82-.24 1.26s.09.85.23 1.24L9.31 16c-.67-.79-1.66-1.31-2.78-1.31-2.02 0-3.65 1.64-3.65 3.65s1.64 3.65 3.65 3.65 3.65-1.64 3.65-3.65c0-.45-.09-.87-.24-1.27l4.75-2.74c.67.81 1.67 1.33 2.8 1.33 2.02 0 3.65-1.64 3.65-3.65s-1.64-3.65-3.65-3.65Zm-11-.3c-1.33 0-2.4-1.08-2.4-2.4s1.08-2.4 2.4-2.4 2.4 1.08 2.4 2.4-1.08 2.4-2.4 2.4m.03 12.69c-1.33 0-2.4-1.08-2.4-2.4s1.08-2.4 2.4-2.4 2.4 1.08 2.4 2.4-1.08 2.4-2.4 2.4m10.97-6.33c-1.33 0-2.4-1.08-2.4-2.4s1.08-2.4 2.4-2.4 2.4 1.08 2.4 2.4-1.08 2.4-2.4 2.4"
      />
    </svg>
  ),
  ArrowUp: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M18.27 10.09 12.62 4.4V22h-1.25V4.4l-5.65 5.69-.89-.88L12 1.99l7.16 7.22z"
      />
    </svg>
  ),
  Funder3: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="m21.99 6-7.95 16H2.05l.62-1.25h10.6L20.6 6H22Zm-9.64 13.01H2.01L10.7 2h10.35l-8.69 17.01ZM9.31 7.46c.66-.28 1.42-.46 2.23-.46 2.05 0 3.76 1.02 4.3 2.42l3.15-6.17h-7.54L9.3 7.46ZM8.3 10.34c0 1.13 1.49 2.09 3.25 2.09s3.25-.96 3.25-2.09-1.49-2.09-3.25-2.09-3.25.96-3.25 2.09m3.29 7.42 2.35-4.59c-.69.32-1.51.52-2.39.52-1.98 0-3.65-.96-4.25-2.28l-3.25 6.36h7.54Z"
      />
    </svg>
  ),
  MapPin: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 2c-4.41 0-8 3.59-8 8 0 1.8.59 3.5 1.7 4.93.15.19.9 1.12 5.33 6.61.24.29.59.47.97.47s.74-.17.97-.47c4.42-5.48 5.18-6.42 5.33-6.61A7.946 7.946 0 0 0 20 10c0-4.41-3.59-8-8-8m5.32 12.16L12 20.75s-5.3-6.56-5.31-6.59A6.747 6.747 0 0 1 12 3.25a6.747 6.747 0 0 1 5.31 10.91ZM12 7.02c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3m0 4.75c-.96 0-1.75-.79-1.75-1.75s.79-1.75 1.75-1.75 1.75.79 1.75 1.75-.79 1.75-1.75 1.75"
      />
    </svg>
  ),
  FlagFill: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path fill="currentColor" d="M22 3H9L1.99 21h1.35l2.72-7H22l-5.99-5.5z" />
    </svg>
  ),
  Calendar: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M16.25 3V2H15v1H9V2H7.75v1H2v19h20V3zm4.5 17.75H3.25V4.25h4.5V6H9V4.25h6V6h1.25V4.25h4.5zm-7.46-4h4.01V18h-5.31v-.62c0-2.54 1.5-3.47 2.7-4.22 1.07-.66 1.84-1.14 1.84-2.52 0-.91-.74-1.64-1.64-1.64s-1.64.74-1.64 1.64H12c0-1.6 1.3-2.89 2.89-2.89s2.89 1.3 2.89 2.89c0 2.08-1.29 2.88-2.43 3.58-.99.62-1.87 1.16-2.06 2.53M8 8h1.25v10H8v-7.95c-.52.38-1.18.65-2 .65V9.45c1.35 0 2-1.17 2-1.46Z"
      />
    </svg>
  ),
  Globe: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M18.25 4.2c-.39-.32-.81-.6-1.25-.85A9.973 9.973 0 0 0 12 2c-1.42 0-2.77.3-4 .84-.43.19-.85.42-1.25.66C4.45 4.93 2.76 7.25 2.2 10c-.08.41-.13.83-.16 1.25-.02.25-.04.5-.04.75 0 5.52 4.48 10 10 10 4.84 0 8.87-3.44 9.8-8 .08-.41.13-.83.16-1.25.02-.25.04-.5.04-.75a9.98 9.98 0 0 0-3.75-7.8M8 11.25h3.75v6.51h-.93l-2.89-6.51h.08ZM6.75 5.02V10H3.49a8.762 8.762 0 0 1 3.26-4.98M12 20.75c-4.82 0-8.75-3.93-8.75-8.75 0-.25.02-.5.04-.75h3.27L10 19h3v-9H8V4.23c1.2-.62 2.56-.98 4-.98 1.86 0 3.58.59 5 1.58V14h3.51c-.91 3.86-4.37 6.75-8.51 6.75m8.71-8h-2.46V5.89a8.727 8.727 0 0 1 2.5 6.11c0 .25-.02.5-.04.75"
      />
    </svg>
  ),
  ArrowLeft: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M22 12.62H4.4l5.69 5.65-.88.89L2 12l7.21-7.16.88.89-5.69 5.65h17.59v1.25Z"
      />
    </svg>
  ),
  Blog: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M16.69 3c-2.05 0-3.8.79-4.69 1.99C11.11 3.8 9.37 3 7.31 3 4.33 3 2 4.67 2 6.81V21h1.25c0-1.39 1.86-2.56 4.06-2.56s4.06 1.17 4.06 2.56h1.25c0-1.39 1.86-2.56 4.06-2.56s4.06 1.17 4.06 2.56h1.25V6.81c0-2.13-2.33-3.81-5.31-3.81Zm-5.31 15.53c-.97-.82-2.41-1.34-4.06-1.34s-3.09.51-4.06 1.33V6.81c0-1.39 1.86-2.56 4.06-2.56s4.06 1.17 4.06 2.56zm9.37-.01c-.97-.82-2.42-1.33-4.06-1.33s-3.09.52-4.06 1.34V6.81c0-1.39 1.86-2.56 4.06-2.56s4.06 1.17 4.06 2.56z"
      />
    </svg>
  ),
  MagnifyingGlass: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M16.08 15.2c1.2-1.4 1.93-3.21 1.93-5.2 0-4.42-3.58-8-8-8S2 5.58 2 10s3.58 8 8 8c1.98 0 3.79-.73 5.19-1.92l5.92 5.93.88-.88-5.92-5.93ZM10 16.75c-3.72 0-6.75-3.03-6.75-6.75S6.28 3.25 10 3.25s6.75 3.03 6.75 6.75-3.03 6.75-6.75 6.75"
      />
    </svg>
  ),
  MinusCircle: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="outline_positive"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path fill="currentColor" d="M6 11.38h12v1.25H6z" />
    </svg>
  ),
  LockClosed: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M18.1 10V7.92C18.1 4.65 15.36 2 12 2S5.9 4.66 5.9 7.92V10H2v12h20V10zM7.15 7.92c0-2.58 2.18-4.67 4.85-4.67s4.85 2.1 4.85 4.67V10h-9.7zm13.6 12.83H3.25v-9.5h17.5zm-8.13-3.74h-1.25V13h1.25z"
      />
    </svg>
  ),
  HandRaised: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M18 5c-.37 0-.7.11-1 .28v-.26C17 3.91 16.1 3 15 3c-.42 0-.8.13-1.12.35C13.6 2.57 12.87 2 12 2s-1.61.57-1.88 1.36C9.8 3.13 9.41 3 8.99 3c-1.1 0-1.98.89-1.98 2v9.55l-1.2-2.41c-.49-1-1.7-1.41-2.69-.93-.99.49-1.4 1.69-.9 2.69l3.79 8.09h10c2.21 0 4-1.79 4-4V7.02c0-1.11-.9-2.02-2-2.02Zm.75 13c0 .41-.1.8-.26 1.16A2.74 2.74 0 0 1 16 20.75H6.73l-1.72-3.97-.62-1.25-1.07-2.17c-.19-.38-.03-.84.34-1.02s.83-.03 1.02.35L6.31 16h1.91V5.02c0-.42.34-.77.76-.77s.76.34.76.77V13h1.5V4.02c0-.42.34-.77.76-.77s.76.34.76.77V13h1.48V5.02c0-.42.34-.77.76-.77s.76.34.76.77V13h1.48V7.02c0-.42.34-.77.76-.77s.76.34.76.77z"
      />
    </svg>
  ),
  CurrencyDollar: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="m15.29 12.78-.91.86a3.3 3.3 0 0 1 .91 2.27c0 1.6-1.15 2.94-2.67 3.23V4.86c1.52.29 2.67 1.63 2.67 3.23h1.25c0-2.29-1.71-4.17-3.92-4.48V2h-1.25v1.61c-2.21.31-3.92 2.19-3.92 4.48s1.71 4.17 3.92 4.48v6.58a3.294 3.294 0 0 1-2.67-3.23H7.45c0 2.29 1.71 4.17 3.92 4.48V22h1.25v-1.6c2.21-.31 3.92-2.19 3.92-4.48 0-.75-.19-1.5-.55-2.17-.19-.35-.43-.68-.71-.97Zm-3.91-1.46c-1.52-.29-2.67-1.63-2.67-3.23s1.15-2.94 2.67-3.23z"
      />
    </svg>
  ),
  ArrowLeftRight: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="outline_positive"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M8.42 12.15 4.4 8.13l15.6.01V6.89L4.4 6.88l4.02-4.02-.88-.88L2.01 7.5l5.52 5.53zM16.46 10.97l-.88.89 4.02 4.02H4v1.25h15.6l-4.02 4.02.89.88 5.52-5.53z"
      />
    </svg>
  ),
  MapPinFill: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 1.99c-4.41 0-8 3.59-8 8.01 0 1.8.59 3.5 1.7 4.93.15.18.9 1.12 5.33 6.61.24.29.59.47.97.47s.74-.17.97-.47c4.42-5.48 5.18-6.42 5.33-6.61A7.946 7.946 0 0 0 20 10c0-4.41-3.59-8-8-8Zm0 11.02c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3"
      />
    </svg>
  ),
  Calculator: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M19.2 2H4.8C3.8 2 3 2.81 3 3.8v16.39c0 1 .81 1.8 1.8 1.8h14.39c1 0 1.8-.81 1.8-1.8V3.8c0-1-.81-1.8-1.8-1.8Zm.55 18.2c0 .3-.25.55-.55.55H4.8c-.3 0-.55-.25-.55-.55V3.8c0-.3.25-.55.55-.55h14.39c.3 0 .55.25.55.55v16.39ZM18 5H6v6h12zm-1.25 4.75h-9.5v-3.5h9.5zM8 14c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1m5 0c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1m5 0c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1M8 18c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1m5 0c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1m5 0c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1"
      />
    </svg>
  ),
  UserPlusFill: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M17.99 17.74c0 1.57-.46 3.02-1.24 4.26H3.25a7.93 7.93 0 0 1-1.24-4.26c0-2.9 1.56-5.44 3.88-6.84h-.01c.49-.3 1.02-.53 1.56-.71a4.487 4.487 0 0 1-1.94-3.7c0-2.49 2.01-4.5 4.5-4.5s4.5 2.01 4.5 4.5c0 1.66-.9 3.09-2.24 3.87-.12.07-.24.14-.37.2-.11.05-.21.09-.32.13-.15.06-.31.11-.47.15-.09.02-.18.05-.28.07-.26.05-.53.08-.81.08h-.02v1.5h.02c1.57 0 3-.61 4.07-1.61.12.07.23.12.35.19A7.993 7.993 0 0 1 18 17.73Zm1.63-9.36V6h-1.25v2.38h-2.38v1.25h2.38v2.38h1.25V9.63H22V8.38z"
      />
    </svg>
  ),
  ChevronDoubleUp: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="m4.51 12.92-.88-.88 8.36-8.37 8.38 8.38-.88.88-7.5-7.5-7.48 7.48Zm-.88 6.06.88.88 7.48-7.48 7.5 7.5.88-.88-8.38-8.38z"
      />
    </svg>
  ),
  ChevronUpDown: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="m7.29 10.22-.88-.88L12 3.75l5.6 5.6-.88.88L12 5.51zM12 18.49l-4.72-4.72-.88.88 5.6 5.6 5.59-5.59-.88-.88z"
      />
    </svg>
  ),
  SortAscendingUp: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="m16.33 13.91.88.88L12 20l-5.21-5.21.88-.88L12 18.24zm-4.95-7.52v5.6h1.25v-5.6l3.7 3.7.88-.88L12 4 6.79 9.21l.88.88 3.7-3.7Z"
      />
    </svg>
  ),
  GlobeFill: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M17 3.35c-.71-.41-1.48-.74-2.29-.97-.07-.02-.14-.04-.22-.06-.32-.08-.64-.15-.96-.2-.1-.02-.2-.03-.3-.05a9.24 9.24 0 0 0-2.28-.02c-.04 0-.09.01-.13.02-.3.04-.6.08-.9.14-.02 0-.03 0-.05.01a9.982 9.982 0 0 0-7.84 9.02c-.02.25-.04.5-.04.75 0 5.52 4.48 10 10 10 .33 0 .65-.02.96-.05.1 0 .21-.03.31-.04.21-.03.42-.06.63-.1.12-.02.24-.05.36-.08.19-.04.37-.09.56-.14.12-.04.24-.07.36-.11.18-.06.35-.12.52-.19.12-.05.23-.09.35-.15.17-.08.34-.16.5-.24.11-.05.22-.11.32-.17.17-.1.34-.2.51-.31.09-.06.18-.11.27-.17.22-.15.44-.31.64-.48.03-.02.05-.04.08-.06.23-.19.45-.39.66-.6.08-.08.15-.16.22-.23.13-.14.27-.28.39-.43.08-.1.16-.19.23-.29.11-.14.22-.28.32-.43.08-.11.15-.22.22-.33.09-.15.18-.29.27-.44.07-.12.13-.23.19-.35.08-.15.15-.31.23-.47.05-.12.11-.24.16-.36.07-.17.13-.35.19-.53.04-.11.08-.23.12-.34.07-.23.13-.47.18-.71.16-.71.25-1.44.25-2.2 0-3.7-2.01-6.92-5-8.65Zm-4 15.66h-3l-3.44-7.76H3.29A8.753 8.753 0 0 1 8 4.23V10h5zM20.51 14H17V4.83A8.74 8.74 0 0 1 20.75 12c0 .69-.09 1.36-.24 2"
      />
    </svg>
  ),
  ChatBubbleLeftEllipsis: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M16 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m-4-2c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1m-4 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1m14 11H7.31C4.39 22 2 19.6 2 16.68V7.3C2 4.38 4.39 2 7.31 2h9.38C19.61 2 22 4.38 22 7.3v6.69c0 2.36-1.57 4.34-3.7 5.03zM7.31 20.75h11.15l-.94-.76-1.8-1.45 2.2-.71c1.7-.55 2.84-2.09 2.84-3.84V7.3a4.06 4.06 0 0 0-4.06-4.05H7.31c-2.24 0-4.06 1.81-4.06 4.05v9.38c0 2.25 1.82 4.07 4.06 4.07"
      />
    </svg>
  ),
  ArrowRightCircle: ({
    onColor,
    ...props
  }: CustomIconProps & { onColor?: boolean }) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("stroke-icon-primary size-6 stroke-0", props.className)}
      {...props}
    >
      <rect width="24" height="24" rx="12" fill="currentColor" />
      <path
        d="M17 12L13.395 15.58L12.955 15.135L15.8 12.31H7V11.685H15.795L12.95 8.85998L13.39 8.41498L16.995 11.995L17 12Z"
        fill={onColor ? "#1C1719" : "white"}
      />
    </svg>
  ),
} as const;
